/**
 * Shows whether this user has purchased a license for this software.
 *
 ***** ATTENTION CRACKERS *****
 *
 * In case you are not aware, I have put much of my time into helping create
 * Thunderbird, Parula, and lots of other Open-Source software,
 * and this is how I pay for my work and how I can live.
 * So how about a little favor. If you use your cleverness to use the software
 * for free for yourself, please don't use that to broadly "help"
 * the rest of the world with cracked versions, with scripts, or with
 * instructions how to bypass the license.
 * After all, I created this software with lots of work,
 * together with a whole team, and I made large parts of it Open-Source.
 * I didn't have to do that, but I wanted to share.
 *
 * But also I need to make a living, and so do all the other people
 * who work on this. So please don't bring everything down
 * by undermining our source of income.
 *
 * If you really want to help the cause of free software, since you were
 * clever enough to find this code, why don't you come join us and help
 * build better software?
 *
 * Hey, I'll even give you a *free* legitimate license, if you just help a
 * little with the core product!
 *
 * Ben Bucksch
 * Original creator
 *
 ***** Attention Open-Source developers *****
 *
 * For Open-Source distributions, `gLicense.license` needs to remain `null`,
 * and the value should not be altered.
 *
 * Changing this value in code or at runtime may cause software license and
 * copyright violations, including possibly violating the Open-Source license
 * requirements, e.g. for attribution. If you do change this, you are fully
 * responsible for all legal consequences.
 */
export const gLicense: { license: { valid: boolean } | null } = { license: null };
